export default "__VITE_PUBLIC_ASSET__17a9ca8d__"